import {
  Activity,
  BarChart3,
  BookOpen,
  ClipboardCheck,
  Cog,
  FileText,
  Landmark,
  LayoutDashboard,
  LifeBuoy,
  ListChecks,
  LucideIcon,
  MessageSquare,
  Settings as SettingsIcon,
  Share2,
  ShieldCheck,
  UserRoundCheck,
  Users,
} from "lucide-react";

import type { PermissionModule } from "@/D2C/features/auth/utils/permissions";
import { ACTIONS } from "./actions";
import { SecureNavItem } from "./type";

// Only modules carrying this action render an entry in the sidebar/header nav;
// other actions (e.g. "list", "add") still grant route access but stay hidden from nav.
export const NAV_VISIBLE_ACTION = ACTIONS.VIEW;

// Icons aren't part of the backend module payload, so they're mapped locally by module_name.
export const MODULE_ICON_REGISTRY: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  pipeline: BarChart3,
  clients: Users,
  calls: MessageSquare,
  quotes: FileText,
  policies: ShieldCheck,
  claims: ClipboardCheck,
  case: LifeBuoy,
  "commission-dashboard": Landmark,
  "commission-ledger": BookOpen,
  invoices: FileText,
  "irdai-compliance": ShieldCheck,
  settings: SettingsIcon,
  "api-monitoring": Activity,
  insurerconfig: UserRoundCheck,
  channels: Share2,
  "review-queue": ListChecks,
  apiconfig: Cog,
  logs: FileText,
};

// Only modules that carry the "view" action show up in the sidebar/header nav, sorted
// by the sequence provided by the backend. Modules without a sequence appear last.
export function getSecureNavItemsFromModules(modules: PermissionModule[]): SecureNavItem[] {
  console.table(
    modules.map((module) => ({
      module: module.module_name,
      displayName: module.display_name,
      sequence: module.sequence ?? "-",
      path: module.path ?? "-",
      actions: module.actions.map((action) => action.action_name).join(", "),
    }))
  );

  return modules
    .filter(
      (module) =>
        Boolean(module?.path) &&
        module?.actions?.some((action) => action?.action_name === NAV_VISIBLE_ACTION)
    )
    ?.map((module) => ({
      id: module?.module_name,
      label: module?.display_name,
      icon: MODULE_ICON_REGISTRY[module?.module_name] ?? FileText,
      module: module?.module_name,
      path: module?.path as string,
    }))
    .sort((a, b) => {
      const sequenceA = modules.find((module) => module.module_name === a.module)?.sequence;
      const sequenceB = modules.find((module) => module.module_name === b.module)?.sequence;

      if (sequenceA == null && sequenceB == null) return a.label.localeCompare(b.label);
      if (sequenceA == null) return 1;
      if (sequenceB == null) return -1;
      return sequenceA - sequenceB;
    });
}
